module.exports = __webpack_public_path__ + "static/20-9-c771c988bbc1ec4d10573189579867e9.jpg";